import { FormEvent } from "react";
import { users } from "../../fake-db/users";
import { useDispatch } from "react-redux";
import { closeModal } from "../../features/globalModalSlice";

const About = () => {
  // dispatch function
  const dispatch = useDispatch();

  // form submit handler
  const handleUpdate = (e: FormEvent) => {
    e.preventDefault();
  };

  return (
    <div className="flex flex-col gap-2 py-2">
      <div className="">
        <h5 className="font-normal text-base text-gray-400 uppercasep py-3">
          About
        </h5>
        <form
          className="w-full flex flex-col gap-3"
          onSubmit={(e) => handleUpdate(e)}
        >
          <textarea
            placeholder="Write something about yourselft"
            className="resize-none border border-gray-300 outline-none rounded-md w-full p-3 text-slate-500 text-base h-40"
            defaultValue={users[0]?.bio}
          ></textarea>
          <input
            type={"email"}
            defaultValue="zissanger@gmail.com"
            placeholder="Your email"
            className="resize-none border border-gray-300 outline-none rounded-md w-full p-3 text-slate-500 text-base"
          />
          <div className="w-full flex justify-end">
            <button
              onClick={() => dispatch(closeModal())}
              type="submit"
              className="px-5 py-2 bg-violet-500 text-white rounded-md w-max"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default About;
